// extracted by mini-css-extract-plugin
export default {"wrapper":"heading_wrapper__-ImNC","header":"heading_header__lZGHd","title":"heading_title__Usbys","icon":"heading_icon__EZOpJ","line":"heading_line__vc32y"};